
/* injects from baggage-loader */

export const TrashTypes = {
    glass: 0,
    metal: 1,
    paper: 0
}

export const TrashIcons = {
    glass: {
        default: require('_images/stages/stage-two/item-glass.png'),
        submerged: require('_images/stages/stage-two/item-glass-submerged.png')
    },
    metal: {
        default: require('_images/stages/stage-two/item-metal.png'),
        submerged: require('_images/stages/stage-two/item-metal-submerged.png')
    },
    paper: {
        default: require('_images/stages/stage-two/item-paper.png'),
        submerged: require('_images/stages/stage-two/item-paper-submerged.png')
    }
}

export const initFeedbackTexts = [
    'Veja! <br>Parece que temos um <b>filhote de onça-pintada</b> do outro lado do rio! Ele está <b>tentando beber água</b>, mas o <b>lixo</b> jogado pelos turistas está <b>atrapalhando</b>.',
    'Por sorte, todo esse <b>lixo</b> é <b>reciclável</b>. Ajude-me a <b>retirar o lixo</b> do rio e <b>separá-lo</b>, de acordo com as cores da <b>coleta seletiva</b>, para deixarmos o <b>rio sem sujeira</b> e a onça-pintada conseguir beber água. <br>Boa sorte!'
];

export const feedbackTexts = [
    'Você conseguiu <b>limpar</b> todo o rio e <b>separar o lixo</b>. Agora o rio está <b>limpo</b> e o filhote poderá <b>beber água</b>',
    'Porém, ainda tenho alguns <b>desafios</b> para você! <br> Vamos lá?'
];


const helpImg = require('_images/stage-helps/onca.png');

export const helpTpl = `
    <div class='container-fluid'>
        <div class='row'>        
            <div class='col-xs-7'>
                <img src='${helpImg}' class='img-responsive' />
            </div>
            <div class='col-xs-5 text-left'>
                <div class='container-fluid'>
                    <p class='subtitle'>Para que a onça-pintada possa beber água, <b>clique e arraste os lixos</b> que estão no rio <b>até as lixeiras de coleta seletiva</b> correspondentes.</p>
                    <p class='subtitle'>Em seguida, você deve <b>observar</b> a cor das colunas do gráfico e <b>inserir a quantidade de lixo</b> referente a cada tipo de material.</p>
                    <p class='subtitle'>Vamos lá!</p>
                </div>
            </div>
        </div>
    </div>
`


// WEBPACK FOOTER //
// ./src/app/pages/stage-two/stage-two.const.js